import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ADMIN_SHELL_ICON_BUTTON_CLASS } from './adminShellChrome.styles.js';

export interface AdminProfileButtonProps {
  /** Opens AdminProfileSheet (Účet / auth actions). */
  readonly onClick: () => void;
  /** Reflects sheet open state for a11y. */
  readonly open?: boolean;
  /** When true, aria uses sign-in copy (guest surfaces). */
  readonly signedOut?: boolean;
  readonly className?: string;
}

/** Icon-only profile control — opens AdminProfileSheet (Účet / Sign out / Sign in). */
export function AdminProfileButton({
  onClick,
  open = false,
  signedOut = false,
  className,
}: AdminProfileButtonProps): JSX.Element {
  const { t } = useTranslation('admin');
  const ariaLabel = signedOut
    ? t('chrome.profile.signInAria')
    : t('chrome.profile.openAria');

  return (
    <button
      type="button"
      className={[ADMIN_SHELL_ICON_BUTTON_CLASS, className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
      title={ariaLabel}
      aria-expanded={open}
      aria-haspopup="dialog"
      data-testid="admin-shell-profile"
      onClick={onClick}
    >
      <User className="h-5 w-5 stroke-[1.75]" aria-hidden />
    </button>
  );
}
